import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import VueResource from 'vue-resource'
import './plugins/bootstrap-vue/bootstrap-vue'
import './plugins/vee-validate'
import './plugins/vue-select'
import './plugins/daterangepicker'
import './plugins/font-awesome'
import './plugins/echarts'
import './plugins/vue2-datepicker'
import './plugins/vue-json-excel'

import App from './App.vue'
import router from './router'
// store
import store from '@/store/index'


import Loading from '@/components/loading/Loading.vue'
import Message from '@/components/message/index.js'
import PmLeftMenu from '@/components/leftmenu/PmMenu.vue'
import PpLeftMenu from '@/components/leftmenu/PpMenu.vue'
import DatePickerRange from '@/components/date-picker-range/Index.vue'


Vue.prototype.$message = Message;

Vue.component('loading', Loading);
Vue.component('pm-left-menu', PmLeftMenu);
Vue.component('pp-left-menu', PpLeftMenu);
Vue.component('date-picker-range', DatePickerRange);


Vue.use(VueResource)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')